import { render, staticRenderFns } from "./ChildCard.vue?vue&type=template&id=c621553c&scoped=true&"
import script from "./ChildCard.vue?vue&type=script&lang=js&"
export * from "./ChildCard.vue?vue&type=script&lang=js&"
import style0 from "./ChildCard.vue?vue&type=style&index=0&id=c621553c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c621553c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardActions,VForm,VIcon,VTextField,VTextarea})
